var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightChevron = function SvgRightChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "rightChevron_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#rightChevron_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.875 17.123a.72.72 0 0 1-.225-.525q0-.3.225-.525l4.075-4.075-4.075-4.075a.72.72 0 0 1-.225-.525q0-.3.225-.525a.72.72 0 0 1 .525-.225q.3 0 .525.225l4.5 4.5a.8.8 0 0 1 .188.287.94.94 0 0 1 0 .675.8.8 0 0 1-.188.288l-4.5 4.5a.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225"
  }))));
};
export default SvgRightChevron;